module.exports = __webpack_public_path__ + "assets/img/main-logo.58f63d9a.png";